import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  type ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@mui/material';

export type ToggleButtonGroupProps = MuiToggleButtonGroupProps;

export const ToggleButtonGroup = (props: ToggleButtonGroupProps) => (
  <MuiToggleButtonGroup data-testid="toggleButtonGroup" {...props} />
);
